import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { every, first, groupBy, last } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import {
  FileType,
  FileStatus,
  RFQStatus,
  RFQStatusLabel,
  FileTypeLabel,
  UserType,
  TemplateType,
} from 'src/app/shared/constants/constants';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { formatBytes, getRFQTemplateLabel } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { RfqService } from '../services/rfq.service';

@Component({
  selector: 'app-rfq-quote',
  templateUrl: './rfq-quote.component.html',
  styleUrls: ['./rfq-quote.component.scss'],
})
export class RfqQuoteComponent implements OnInit, OnChanges {
  @Output() childClick = new EventEmitter<string>();
  @Output() updateRfqList = new EventEmitter<void>();

  baseUrl = environment.BASE_URL;
  @ViewChild('fileDropRef', { static: false }) fileDropEl:
    | ElementRef
    | undefined;
  @ViewChild('fileSelector') fileSelector!: ElementRef;
  @ViewChild('singleFileDropRef', { static: false }) singleFileDropRef:
    | ElementRef
    | undefined;
  @ViewChild('singleFileSelector') singleFileSelector!: ElementRef;

  //  singleFileDropRef!: ElementRef;
  //   @ViewChild('singleFileDropRef', { static: false }) set singleContent(singleContent: ElementRef) {
  //      if(singleContent) { // initially setter gets called with undefined
  //          this.singleFileDropRef = singleContent;
  //      }
  //   }

  //    singleFileSelector!: ElementRef;
  //   @ViewChild('singleFileSelector', { static: false }) set singleFileContent(singleFileContent: ElementRef) {
  //      if(singleFileContent) { // initially setter gets called with undefined
  //          this.singleFileSelector = singleFileContent;
  //      }
  //   }

  RFQStatusLabel: any = RFQStatusLabel;
  RFQStatus: any = RFQStatus;
  FileType: any = FileType;
  fileStatus: any = FileStatus;
  files: any[] = [];
  //singleFiles: any[] = [];
  isExpanded: boolean = false;
  isMoreExpanded: boolean = false;
  FileTypeLabel: any = FileTypeLabel;
  fileTypeGroup: any = {};
  rfqItem: any;
  customerName: any;
  companyId: string = '';
  attachments: any[] = [];
  attachedFiles: any[] = [];
  fileUpload: boolean = false;
  saveButtonEnable: Boolean = false;
  rfqTemplate: FormControl = new FormControl('');
  isPoExpanded: boolean = true;
  poFileUpload: boolean = false;
  quotreReturn: boolean = false;
  quoteReasonData: any;
  returnQuoteForm!: FormGroup;
  ArchiveAndDiscontinueForm!: FormGroup;
  SingleFile!: any;
  uploadAgainPO = false;
  quatefileId: any[] = [];
  Sendarchive: boolean = false;
  rfqDetailData: any;
  otherResonArchiveNdDiscontiRetchk: boolean = false;
  otherResonQuoteRetchk: boolean = false;
  templateType = TemplateType;

  @Input() rfqData!: any;
  @Output() closeSideNav = new EventEmitter<boolean>();
  archivedPOFile: any;
  lineItems: any;
  custRfqId: any;
  showHideAttachments: boolean = false;
  constructor(
    private toastr: ToastrService,
    private commonService: CommonService,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private rfqService: RfqService,
  ) {
    this.companyId = sessionStorage.getItem('customercompanyId') || '';
  }
  // matchip = ["CNC Machinig","3D Prinitng"];
  toggleAccordion() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit(): void {
    this.getCustomerName();
    this.createReturnQuoteForm();
    this.createArchiveAndDiscontinueForm();
  }

  closeRfqQuote() {
    this.isExpanded = false;
    this.fileUpload = false;
    this.childClick.emit();
    this.quotreReturn = false;
  }

  uploadNewPO(): void {
    this.uploadAgainPO = !this.uploadAgainPO;
  }

  closeUploadPo() {
    this.isPoExpanded = false;
    this.poFileUpload = false;
    this.childClick.emit();
  }
  getRfqCustomerDetail(customerRfqPrimaryId: number) {
    let apiUrl = `${this.baseUrl}rfq/customer/rfq/get/${customerRfqPrimaryId}`;
    this.commonService.getData(apiUrl).subscribe((data) => {
      this.rfqItem = data.response;
      this.archivedPOFile = data.response.attachments.filter(
        (file: { fileStatus: string; fileType: string }) => {
          return (
            file.fileStatus == FileStatus.Archive &&
            file.fileType == FileType.PO
          );
        }
      );
      this.attachedFiles = this.rfqItem?.attachments;
      this.groupAttachmentsByFileType();
    });
  }
  ngOnChanges(rfqData: any): void {
    const rfqItemData = rfqData.rfqData.currentValue;
    this.custRfqId = rfqData.rfqData.currentValue.customerRfqPrimaryId;
    this.getRfqCustomerDetail(rfqItemData.customerRfqPrimaryId);

    if (rfqItemData?.status && rfqItemData.status == RFQStatus.QUOTE_RETURNED) {
      this.getQuoteReturnReason();
    }
  }
  formatBytes(size: number): string {
    return formatBytes(size);
  }
  openUpdteRfq(rfq: any) {
    this.router.navigate(['customer/rfq/create-rfq', rfq?.id]);
  }

  deleteFile(index: number) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete',
        content: 'Are you sure you want to delete this file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        if (this.files[index]?.progress < 100) {
          return;
        }
        this.files.splice(index, 1);
        this.fileSelector.nativeElement.value = '';
        this.getFileUploadS3UrlAndUpload('File deleted successfully');
      }
    });
  }
  onSingleFileDropped($event: any) {
    let eve = {
      target: {
        files: $event,
      },
    };
    this.fileBrowseHandlerSingle(eve);
    // this.prepareFilesPOList($event);
  }
  fileBrowseHandler(files: any) {
    this.prepareFilesList(files?.target?.files);
  }
  filePoBrowseHandler(files: any) {
    this.prepareFilesPOList(files?.target?.files);
  }
  prepareFilesPOList(files: Array<any>) {
    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.files.push(item);
    }
    if (this?.singleFileDropRef) {
      this.singleFileSelector.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUploadSingleFile();
  }

  preparePoFilesList(files: Array<any>) {
    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.files.push(item);
    }
    if (this?.fileDropEl) {
      this.singleFileSelector.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUploadSingleFile();
  }
  prepareFilesList(files: Array<any>) {
    const fileExt = last(files[0].name.split('.'));
    if (fileExt !== 'xlsx') {
      this.toastr.error('Invalid file extension');
      return;
    }

    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.files.push(item);
    }
    if (this?.fileDropEl) {
      this.fileDropEl.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUpload('File uploaded successfully');
  }

  getFileUploadS3UrlAndUpload(msg: string): void {
    this.attachments = [];
    if (this.files.length) {
      this.files.forEach((file) => {
        const fileNameList = file?.name?.split('.');
        const filesData = {
          fileName: file.name,
          type: file.type,
          size: formatBytes(file.size),
          userType: UserType.Customer,
          location: `Customer/Additional/${this.rfqItem.id}/tooling}/${fileNameList[0]}.${fileNameList[1]}`,
          documentUseFor: FileType.RFQ,
        };
        this.commonService
          .postDatawithoutHeaders(
            `${this.baseUrl}auth-service/file-management`,
            filesData
          )
          .subscribe({
            next: async (data: any) => {
              const attachment = {
                id: data.response.id,
                type: file.type,
                rfqTemplateType: first(this.rfqItem.rfqTemplate),
                fileName: file.name,
                updatedOn: new Date(),
                fileType: FileType.Additional,
                location:data.response.location,
                presignedUrl:data.response.presignedUrl,
                size: formatBytes(file.size),
              };

              this.attachments.push(attachment);
              // this.fileUploadDoc = data.response;
              let msg1 = '';
              if (this.files.length == this.attachments?.length) {
                msg1 = msg;
              }
              await this.awsBasicUploadSingle(
                data.response.presignedUrl,
                file,
                msg1
              );
            },
            error: (error: HttpErrorResponse) => {
              this.toastr.error(error.error.status.error.message);
            },
          });
      });
    }
  }

  async awsBasicUploadSingle(url: string, file: File, msg: string) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
    };
    this.http.put(url, file, HttpUploadOptions).subscribe({
      next: (data: any) => {
        // this.fileUploadDoc.fileUploadStatus = true;
        // this.fileUploadEvent.emit(this.fileUploadDoc);
        if (msg != '') {
          this.toastr.success(msg);
        }
      },
      error: (error: HttpErrorResponse) => {
        // this.fileUploadDoc.fileUploadStatus = false;
        this.toastr.error(error.error.status.error.message);
      },
    });
    this.closeNavExpantion();
  }
  async awsBasicUploadPOSingle(url: string, file: File) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
    };
    this.http.put(url, file, HttpUploadOptions).subscribe({
      next: (data: any) => {
        // this.fileUploadDoc.fileUploadStatus = true;
        // this.fileUploadEvent.emit(this.fileUploadDoc);
        this.toastr.success(`File uploaded successfully ${file.name}`);
      },
      error: (error: HttpErrorResponse) => {
        // this.fileUploadDoc.fileUploadStatus = false;
        this.toastr.error(error.error.status.error.message);
      },
    });
    this.closeNavPoExpantion();
  }

  updateRFQFile() {
    let apiURL = `${this.baseUrl}rfq/customer/`;
    const payLoad = {
      customerId: Number(this.companyId),
      customerName: this.customerName,
      rfqTemplate: [first(this.rfqItem.rfqTemplate)],
      secondaryProcess: this.rfqItem.secondaryProcesses,
      material: this.rfqItem.materials,
      category: this.rfqItem.category,
      projectName: this.rfqItem.projectName,
      attachments: this.attachments,
      createdSource: 'portal',
      paymentTerm: this.rfqItem.paymentTerm,
      paymentTermRemarks: this.rfqItem.paymentTermRemarks,
      incoTerm: this.rfqItem.incoTerm,
      address: this.rfqItem.address,
      moq: this.rfqItem.moq,
      deliveryDate: this.rfqItem.deliveryDate,
      countryName: this.rfqItem.countryName,
    };

    let subcategory: [] = this.rfqItem.subCategory;

    if (subcategory) {
      for (let val of subcategory) {
        payLoad.category.push(val);
      }
    }
    this.commonService.update(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }
  
  updatePOFile() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Upload PO',
        content: 'Are you sure you want to upload this file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          attachments: [
            {
              id: this.attachments[0].id,
              fileName: this.attachments[0].fileName,
              type: this.attachments[0].type,
              location: this.attachments[0].location,
              presignedUrl: this.attachments[0].presignedUrl,
              rfqTemplateType: this.attachments[0].rfqTemplateType,
              size: this.attachments[0].size,
              updatedOn: this.attachments[0].updatedOn,
              fileType: FileType.PO,
            },
          ],
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Upload',
        };
        

        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            this.toastr.success('PO Raised Successfully');
            this.updateRfqListData();
            //this.closeUploadPo();
            //this.closeRfqQuote();
          },
        });
      }
    });
  }
  updatePOStatus() {
    // {{DEV_BASE_URL}}/rfq/customer/84/PO_Raised
    let apiURL = `${this.baseUrl}rfq/customer/${this.rfqItem.id}/PO_RAISED`;
    const payLoad = {};
    this.http.post(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }

  chooseFiles() {
    if (this?.fileSelector) {
      let el: HTMLElement = this?.fileSelector?.nativeElement;
      el.click();
    }
  }

  filePath: any;
  saveFile(file: any): void {
    let apiUrl = `${this.baseUrl}auth-service/file-management?id=${file.id}`;
    this.commonService.getData(apiUrl).subscribe((res) => {
      this.filePath = res.response;
      let link = document?.createElement('a');
      link.href = this.filePath;
      link.download = file.name;
      link.target = '_blank';
      link.click();
    });
  }

  async downloadAllQuoteFiles(fileList: any): Promise<void> {
    if (fileList?.length > 0) {
      for (const item of fileList) {
        if (
          (item.fileType == FileType.Quote_Tooling ||
            item.fileType == FileType.Quote_Component ||
            item.fileType == FileType.Quote_Capex ||
            item.fileType == FileType.Quote) &&
          item.fileStatus == FileStatus.Live
        ) {
          await this.downloadFiles(item.id, item.fileName);
        }
      }
      this.toastr.success(`All files downloaded successfully`);
    }
  }

  downloadFiles(id: number, fileName: string): void {
    let apiUrl: string = `${this.baseUrl}auth-service/file-management?id=${id}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
      },
      error: (error) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }

  getCustomerName() {
    let apiURL = `${this.baseUrl}customer/company-management/getCompanyDetails?companyId=${this.companyId}`;
    this.commonService.getData(apiURL).subscribe((res) => {
      this.customerName = res.response.name;
    });
  }

  getFileName(name: string): string {
    return name.split('.')[0];
  }

  getFileExt(name: string): string {
    return name.split('.')[1];
  }

  saveRFQ() {}
  navExpantion() {
    this.isExpanded = false;
    this.fileUpload = true;
  }
  closeNavExpantion() {
    this.isExpanded = true;
    this.fileUpload = false;
  }
  closeNavPoExpantion() {
    this.isPoExpanded = true;
    this.poFileUpload = false;
  }
  navPoExpantion() {
    this.isPoExpanded = false;
    this.poFileUpload = true;
  }
  chooseFileSingle() {
    if (this?.fileSelector) {
      let el: HTMLElement = this?.fileSelector?.nativeElement;
      el.click();
    }
  }
  getFileUploadS3UrlAndUploadSingleFile() {
    const fileNameList = this.SingleFile?.name?.split('.');
    const filesData = {
      fileName: this.SingleFile.name,
      type: this.SingleFile.type,
      size: formatBytes(this.SingleFile.size),
      userType: UserType.Customer,
      location: `Customer/rfq/${this.rfqItem.id}/${this.rfqItem?.rfqTemplate}/${this.SingleFile.name}.${this.SingleFile.name}`,
      documentUseFor: FileType.RFQ,
    };

    this.http
      .post(`${this.baseUrl}auth-service/file-management`, filesData)
      .subscribe({
        next: (data: any) => {
          // this.fileUploadDoc = data.response;

          const attachment = {
            id: data.response?.id,
            type: this.SingleFile.type,
            rfqTemplateType: this.rfqItem?.rfqTemplate, //tooling component capex
            fileName: this.SingleFile.name,
            updatedOn: new Date(),
            fileType: FileType.PO,
            location:data.response.location,
            presignedUrl:data.response.presignedUrl,
            size: formatBytes(this.SingleFile.size),
          };
          this.attachments.push(attachment);
          this.awsBasicUploadPOSingle(
            data.response.presignedUrl,
            this.SingleFile
          );
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
  }
  fileBrowseHandlerSingle(event: any) {
    let files = event?.target?.files;

    const fileExt = last(files[0].name.split('.')) as string;

    if (!['xls', 'xlsx', 'pdf'].includes(fileExt)) {
      this.toastr.error('Invalid file extension');
      return;
    }

    if (files[0].progress) {
      files[0].progress = 0;
    }
    this.SingleFile = files[0];
    if (this?.fileDropEl) {
      this.singleFileSelector.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUploadSingleFile();
  }
  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }
  chooseSingleFiles() {
    if (this.singleFileSelector) {
      let el: HTMLElement = this.singleFileSelector?.nativeElement;
      el.click();
    }
  }
  blankFile!: File;
  removeFile() {
    this.SingleFile = this.blankFile;
    this.singleFileSelector.nativeElement.value = '';
  }
  getSingleFileName(name: string): string {
    return name.split('.')[0];
  }
  getSingleFileExt(name: string): string {
    return name.split('.')[1];
  }
  acceptQuote() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Accept Quote',
        content: 'Are you sure you want to accept this quote?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Accept',
        };
        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            this.toastr.success('Quote Accepted Successfully');
            this.updateRfqListData();
          },
          error: (error: HttpErrorResponse) => {
            this.toastr.error(error.error.status.error.message);
          },
        });
      }
    });
  }
  returnQuote() {
    this.quotreReturn = true;
  }
  backQuote() {
    this.quotreReturn = false;
  }
  createReturnQuoteForm() {
    this.returnQuoteForm = new FormGroup({
      reason: new FormControl('', Validators.required),
      detailedReason: new FormControl('', Validators.required),
    });
  }

  disabledSubmitQuoteReturn(): boolean {
    let value: boolean = false;
    if (
      this.returnQuoteForm.value.reason === 'others' &&
      this.returnQuoteForm.value.detailedReason === ''
    ) {
      value = true;
    }
    if (this.returnQuoteForm.value.reason === '') {
      value = true;
    }
    return value;
  }

  reasonForReturn(val: any) {
    if (val == 'others') {
      this.otherResonQuoteRetchk = true;
      this.returnQuoteForm
        .get('detailedReason')
        ?.setValidators(Validators.required);
    } else {
      this.otherResonQuoteRetchk = false;
      this.returnQuoteForm
        .get('detailedReason')
        ?.removeValidators(Validators.required);
    }
  }

  confirmSubmission() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Return this quote',
        content: 'Are you sure, you want to return the quote?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        this.submitFeedback();
      }
    });
  }

  submitFeedback() {
    let poFileIdType = this.rfqItem.attachments;
    poFileIdType.forEach((item: { id: any }) => {
      this.quatefileId = item?.id;
    });
    const payload = {
      customerRfqId: this.rfqItem.id,
      attachmentIds: [this.quatefileId],
      returnReason: this.returnQuoteForm.value.reason,
      reasonOthers: this.returnQuoteForm.value.detailedReason,
      service: 'customer',
    };
    const apiURL = `${this.baseUrl}rfq/common/returnQuote`;
    this.commonService.postDatawithoutHeaders(apiURL, payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Quote Returned successfully');
        this.returnQuoteForm.reset();
        this.updateRfqListData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }
  getQuoteReturnReason() {
    if (this.rfqItem?.id) {
      this.commonService
        .getData(
          `${this.baseUrl}rfq/customer/getReturnDetails/${this.rfqItem.id}`
        )
        .subscribe((res) => {
          this.quoteReasonData = res?.response;
        });
    }
  }
  updateRfqListData(): void {
    this.updateRfqList.emit();
  }
  downloadQuote(id: number, fileName: string): void {
    let apiUrl: string = `${this.baseUrl}auth-service/file-management?id=${id}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
      },
      error: (error) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }
  getStatusLabel(status: any): string {
    return this.RFQStatusLabel[status];
  }

  //----------Grouping of files based on file type------//
  getFileTypeLabel(fileType: any): string {
    return this.FileTypeLabel[fileType];
  }
  groupAttachmentsByFileType(): any {
    const result: any = groupBy(this.rfqItem?.attachments, 'fileType');
    this.fileTypeGroup = result;
  }

  getFileTypes(): any[] {
    return Object.entries(this.fileTypeGroup).map(([key, value]) => ({
      key,
      value,
    }));
  }

  createArchiveAndDiscontinueForm() {
    this.ArchiveAndDiscontinueForm = new FormGroup({
      reason: new FormControl('', Validators.required),
      detailedReason: new FormControl('', Validators.required),
    });
  }

  reasonForArchiveAndDiscontinuationReturn(val: any) {
    if (val == 'others') {
      this.otherResonArchiveNdDiscontiRetchk = true;
      this.ArchiveAndDiscontinueForm.get('detailedReason')?.setValidators(
        Validators.required
      );
    } else {
      this.otherResonArchiveNdDiscontiRetchk = false;
      this.ArchiveAndDiscontinueForm.get('detailedReason')?.removeValidators(
        Validators.required
      );
    }
  }

  submitArchiveAndDiscontinue() {
    let apiUrl = `${this.baseUrl}rfq/common/archive`;
    let payLoad = {
      customerRFQId: this.rfqItem.customerRfqPrimaryId,
      reason: this.ArchiveAndDiscontinueForm.value.reason,
      detailedReason: this.ArchiveAndDiscontinueForm.value.detailedReason,
      service: 'customer',
    };
    this.commonService.update(apiUrl, '', payLoad).subscribe({
      next: (data: any) => {
        this.toastr.success('Sent to Archive successfully');
        this.updateRfqListData();
      },
      error: (error) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
    this.Sendarchive = false;
  }
  isPreviousQuote(previousRfq: any[]): boolean {
    if (
      previousRfq?.some(
        (rfqItem: any) =>
          (rfqItem.fileType === FileType.Quote ||
            rfqItem.fileType === FileType.Quote_Tooling ||
            rfqItem.fileType === FileType.Quote_Component ||
            rfqItem.fileType === FileType.Quote_Capex) &&
          rfqItem.fileStatus === FileStatus.Archive
      )
    ) {
      return true;
    } else {
      return false;
    }
  }
  isLatestQuote(latestRfq: any): boolean {
    if (
      latestRfq?.some(
        (rfqItem: any) =>
          (latestRfq?.fileType === FileType.Quote ||
            latestRfq?.fileType === FileType.Quote_Tooling ||
            latestRfq?.fileType === FileType.Quote_Component ||
            latestRfq?.fileType === FileType.Quote_Capex) &&
          latestRfq?.fileStatus === FileStatus.Live
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  getRFQTemplateLabel(rfqType: TemplateType): string {
    return getRFQTemplateLabel(rfqType);
  }

  toggleAttachments(): void {
    this.showHideAttachments = !this.showHideAttachments;
  }
}
